
import { httpRequest } from "../../http";

export class CommandNotebook {
    async run(organizationId: number) {  
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/notebooks/`
        const body = {
            organization: {
                id: organizationId,
            },
        }
        try {
            const response = await httpRequest<any>(url, { method: "POST", body });
            return response;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

